import { useMutation, useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api/client";
import { queryClient } from "../app/queryClient";
import type { User } from "../types";

export function useAuth() {
  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => apiFetch<{ user: User }>("/api/auth/me"),
  });
}

export function useLogin() {
  return useMutation({
    mutationFn: (payload: { email: string; password: string }) =>
      apiFetch<{ user: User }>("/api/auth/login", { method: "POST", body: payload }),
    onSuccess: (data) => queryClient.setQueryData(["auth", "me"], data),
  });
}

export function useLogout() {
  return useMutation({
    mutationFn: () => apiFetch("/api/auth/logout", { method: "POST", body: {} }),
    onSuccess: () => queryClient.clear(),
  });
}
